import { render, staticRenderFns } from "./studyMetadata.vue?vue&type=template&id=334aa57b&"
import script from "./studyMetadata.vue?vue&type=script&lang=js&"
export * from "./studyMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports